import { Region } from '../interfaces/Region'

export const regionUK = 'uk' as const
export const regionUS = 'us' as const
export const regionDE = 'de' as const

export const regionOptions = [
	{
		label: 'United Kingdom',
		value: regionUK
	},
	{
		label: 'United States',
		value: regionUS
	},
	{
		label: 'Germany',
		value: regionDE
	}
] as const

// regions that are disabled for the given environment
export const envRegionsDisabled: { [key in Region]: string[] } = {
	[regionUK]: [],
	[regionUS]: ['local', 'nightly', 'beta'],
	[regionDE]: []
}
